import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { en, lt } from "internationalization/locales";
import { Language } from "types";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "lt",
    supportedLngs: Object.values(Language),
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: en,
      },
      lt: {
        translation: lt,
      },
    },
  });

export default i18next;
